import { engineComponent, EngineComponentFactory } from "neo-common";
import { HtmlContainerElement } from "../../../HTMLComponents/Elements/HtmlContainerElement";
import { ComponentTypes } from "../../../Components/ComponentTypes";
import { ActionsTypes, ActionSet } from "../Actions/ActionSet";
import { Controller } from "../../../GameComponents/Controller";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { GameManager } from "../../../Managers/GameManager";
import { AppContext } from "../../../../Common/AppContext";
import { GameData } from "../Datas/GameData";
import { DataManager } from "../../../Managers/DataManager";
import { BetManager } from "../../../Managers/BetManager";
import { FreeRoundBonus } from "../Bonuses/FreeRoundBonus";

@engineComponent(ComponentTypes.HtmlElement)
export class UserControls extends HtmlContainerElement {
    protected _key: string = "";
    protected _actions: ActionSet;

    private _betLabel: HTMLElement;
    private _freeBetLabel: HTMLElement;
    private _betLabelFS: HTMLElement;
    private _freeBetLabelFS: HTMLElement;
    private _betValue: HTMLElement;
    private _betPlus: HTMLElement;
    private _betMinus: HTMLElement;
    private _uncollectedWin: HTMLElement;
    private _collectedWin: HTMLElement;

    constructor(key: string) {
        super();

        this._key = key;

        this._actions = new ActionSet(`${this._key}.actions`, EngineComponentFactory.getComponentName(this));
    }

    protected get actions(): ActionSet {
        return this._actions;
    }

    getAllActions(): ActionsTypes {
        return this._actions.getAllActions();
    }

    create(node: Element): void {
        super.create(node);
    }

    addController(controller: Controller): void {}

    initReceived(): void {
        this._uncollectedWin = document.getElementById("uncollectedWin");
        this._collectedWin = document.getElementById("collectedWin");
    }

    collectReceived(): void {}

    dispatchAction(action: string): void {}

    collect(): void {}

    initIntro(): void {}

    flashBet(): void {
        if (this._betValue == null) {
            this._betValue = document.getElementById("betValue");
        }

        if (this._betValue != null) {
            this._betValue.classList.remove("flash");
            setTimeout(() => this._betValue.classList.add("flash"), 33);
            setTimeout(() => this._betValue.classList.remove("flash"), 2000);
            PlayList.play("SND_LowCredit");
        }
    }

    initNewBet(animate: boolean = true): void {
        if (this._betLabel == null) {
            this._betLabel = document.getElementById("betLabel");
        }

        if (this._freeBetLabel == null) {
            this._freeBetLabel = document.getElementById("freeBetLabel");
        }

        if (this._betLabelFS == null) {
            this._betLabelFS = document.getElementById("betLabelFS");
        }

        if (this._freeBetLabelFS == null) {
            this._freeBetLabelFS = document.getElementById("freeBetLabelFS");
        }

        if (this._betValue == null) {
            this._betValue = document.getElementById("betValue");
        }

        if (this._betPlus == null) {
            this._betPlus = document.getElementById("betPlus");
        }

        if (this._betMinus == null) {
            this._betMinus = document.getElementById("betMinus");
        }

        if (FreeRoundBonus.inFrb) {
            if (this._betLabel != null && !this._betLabel.classList.contains("_hidden")) {
                this._betLabel.classList.add("_hidden");
            }
            if (this._freeBetLabel != null) {
                if (this._freeBetLabel.classList.contains("_hidden")) {
                    this._freeBetLabel.classList.remove("_hidden");
                }
                if (animate) {
                    this._freeBetLabel.classList.remove("flash");
                    setTimeout(() => this._freeBetLabel.classList.add("flash"), 33);
                    setTimeout(() => this._freeBetLabel.classList.remove("flash"), 2000);
                }
            }
            if (this._betLabelFS != null && !this._betLabelFS.classList.contains("_hidden")) {
                this._betLabelFS.classList.add("_hidden");
            }
            if (this._freeBetLabelFS != null) {
                if (this._freeBetLabelFS.classList.contains("_hidden")) {
                    this._freeBetLabelFS.classList.remove("_hidden");
                }
            }
        } else {
            if (this._freeBetLabel != null && !this._freeBetLabel.classList.contains("_hidden")) {
                this._freeBetLabel.classList.add("_hidden");
            }
            if (this._betLabel != null) {
                if (this._betLabel.classList.contains("_hidden")) {
                    this._betLabel.classList.remove("_hidden");
                }
                if (animate) {
                    this._betLabel.classList.remove("flash");
                    setTimeout(() => this._betLabel.classList.add("flash"), 33);
                    setTimeout(() => this._betLabel.classList.remove("flash"), 2000);
                }
            }

            if (this._freeBetLabelFS != null && !this._freeBetLabelFS.classList.contains("_hidden")) {
                this._freeBetLabelFS.classList.add("_hidden");
            }
            if (this._betLabelFS != null) {
                if (this._betLabelFS.classList.contains("_hidden")) {
                    this._betLabelFS.classList.remove("_hidden");
                }
            }
        }

        if (this._betValue != null) {
            if (animate) {
                this._betValue.classList.remove("flash");
                setTimeout(() => this._betValue.classList.add("flash"), 33);
                setTimeout(() => this._betValue.classList.remove("flash"), 2000);
            }
        }

        if (BetManager.TotalBets.length > 1) {
            if (this._betPlus != null && this._betPlus.classList.contains("_invisible")) {
                this._betPlus.classList.remove("_invisible");
            }

            if (this._betMinus != null && this._betMinus.classList.contains("_invisible")) {
                this._betMinus.classList.remove("_invisible");
            }
        } else {
            if (this._betPlus != null && !this._betPlus.classList.contains("_invisible")) {
                this._betPlus.classList.add("_invisible");
            }

            if (this._betMinus != null && !this._betMinus.classList.contains("_invisible")) {
                this._betMinus.classList.add("_invisible");
            }
        }
    }

    changeBetColor(green: boolean = false): void {
        if (this._betValue == null) {
            this._betValue = document.getElementById("betValue");
        }

        if (this._betValue != null) {
            if (green) {
                this._betValue.style.color = "#39ff04";
            } else {
                this._betValue.style.color = "#ffffff";
            }
        }
    }

    playCollectSound(): void {
        if (GameManager.gameResponse.totalWin > 0) {
            if (FreeRoundBonus.inFrb && FreeRoundBonus.winPayMethod !== "cumulative") {
                PlayList.play("SND_BaseCollect");
            } else if (!FreeRoundBonus.inFrb) {
                PlayList.play("SND_BaseCollect");
            }
        }
    }

    cycleHelp(): void {}

    changeWinBox(collect: boolean = false): void {
        if (AppContext != null && !AppContext.gameConfiguration.CollectOnUnCalculatedWin) {
            return;
        }
        if (this._uncollectedWin != null) {
            if (collect) {
                if (!this._uncollectedWin.classList.contains("_hidden")) {
                    this._uncollectedWin.classList.add("_hidden");
                }
            } else {
                if (this._uncollectedWin.classList.contains("_hidden")) {
                    DataManager.updateDataElement(GameData.DataTotalWin, "0");
                    DataManager.updateDataElement(GameData.DataTotalWinDenom, "0");
                    this._uncollectedWin.classList.remove("_hidden");
                }
            }
        }
        if (this._collectedWin != null) {
            if (collect) {
                if (this._collectedWin.classList.contains("_hidden")) {
                    this._collectedWin.classList.remove("_hidden");
                }
            } else {
                if (!this._collectedWin.classList.contains("_hidden")) {
                    this._collectedWin.classList.add("_hidden");
                }
            }
        }
    }

    restoreGameRound(): void {}
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/UserControls/UserControls.ts
 **/